import styled from 'styled-components';

export const G2FSSContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;
